import { motion } from 'framer-motion';

export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'Design & Konzept',
      description: 'Ich erstelle ein maßgeschneidertes Design, das Ihre Marke widerspiegelt.',
      icon: 'ri-palette-line'
    },
    {
      number: '02',
      title: 'Entwicklung & AI-Integration',
      description: 'Ich entwickle Ihre Webseite mit modernster Technologie und integriere KI-Funktionen, die Ihre Besucher begeistern und in Kunden verwandeln.',
      icon: 'ri-code-s-slash-line'
    },
    {
      number: '03',
      title: 'Launch & Betreuung',
      description: 'Nach dem Launch begleite ich Sie weiter – mit persönlichem Support, regelmäßigen Updates und kontinuierlicher Optimierung für langfristigen Erfolg.',
      icon: 'ri-rocket-line'
    }
  ];

  return (
    <section className="relative bg-brand-beige-light overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 py-20 sm:py-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16 sm:mb-20"
        >
          <span className="inline-block text-brand-green text-sm font-semibold tracking-widest uppercase mb-3">Mein Prozess</span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-caprasimo mb-4 sm:mb-6 text-brand-black px-4">
            So arbeite ich
          </h2>
          <p className="text-lg sm:text-xl text-brand-grey max-w-3xl mx-auto px-4">
            In drei einfachen Schritten zu Ihrer neuen Webseite
          </p>
        </motion.div>

        <div className="relative">
          <div className="hidden lg:block absolute top-[3.5rem] left-[16.67%] right-[16.67%] h-px bg-gradient-to-r from-transparent via-brand-green/30 to-transparent z-0"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 max-w-5xl mx-auto">
            {steps.map((step, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="relative bg-white rounded-2xl p-6 sm:p-8 overflow-hidden group hover:shadow-2xl transition-shadow"
              >
                {/* Schritt-Nummer */}
                <div className="absolute top-4 right-5 text-4xl font-caprasimo text-brand-beige-light select-none">
                  {step.number}
                </div>

                {/* Icon */}
                <div className="w-14 h-14 flex items-center justify-center bg-brand-beige-light rounded-xl mb-6 group-hover:bg-brand-green group-hover:scale-110 transition-all">
                  <i className={`${step.icon} text-2xl text-brand-green group-hover:text-white transition-colors`}></i>
                </div>

                {/* Titel */}
                <h3 className="text-xl font-caprasimo mb-4 text-brand-black group-hover:text-brand-green transition-colors leading-snug">
                  {step.title}
                </h3>

                {/* Beschreibung */}
                {step.description ? (
                  <p className="text-brand-grey leading-relaxed text-sm">{step.description}</p>
                ) : null}
              </motion.div>
            ))}
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
          className="text-center mt-16"
        >
          <a
            href="/contact"
            className="inline-block text-white px-8 sm:px-10 py-4 rounded-lg text-base sm:text-lg font-semibold transition-all cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl hover:scale-105"
            style={{ background: 'linear-gradient(135deg, #16a34a, #15803d)' }}
          >
            Jetzt Projekt starten
          </a>
        </motion.div>
      </div>
    </section>
  );
}
